import script from "./BlockedUserErrorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockedUserErrorDialog.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BlockedUserErrorDialog.vue?vue&type=style&index=0&id=2d9c57fa&module=true&scoped=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-2d9c57fa"]])

export default __exports__